import {Component} from '@angular/core';
import {FieldWrapper, FormlyModule} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';
import {NzCardModule} from 'ng-zorro-antd/card';

@Component({
  selector: 'zorrly-wrapper-nz-form-field',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    NzCardModule,
  ],
  template: `
      <nz-card [nzTitle]="props['title']">
          <ng-container #fieldComponent></ng-container>
      </nz-card>
  `
})
export class ZorrlyCardWrapperComponent extends FieldWrapper {
  get errorState() {
    return this.showError ? 'error' : '';
  }
}
